module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', [(!_vm.isAeonlifeUnderwriting) ? _c('m-timer-tip', {
    attrs: {
      "countdownTimer": _vm.countdownTimer
    }
  }) : _vm._e(), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "订单号"
    }
  }, [_vm._v(_vm._s(_vm.orderCode))]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "产品名称"
    }
  }, [_vm._v(_vm._s(_vm.productName))]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "支付金额"
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.thisPrice))]), _vm._v("元\n      ")])]), _vm._v(" "), (['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) !== -1) ? _c('cell', {
    attrs: {
      "title": "返现金额",
      "primary": "content"
    }
  }, [_c('div', [_c('span', {
    staticClass: "ticket-tip",
    on: {
      "click": _vm.showTicketDialog
    }
  }, [_vm._v("?")]), _vm._v(_vm._s(_vm.backMoney) + "元")])]) : _vm._e(), _vm._v(" "), (['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) !== -1) ? _c('cell', {
    attrs: {
      "title": "实际支付",
      "primary": "content"
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "rgb(252, 158, 137)"
    }
  }, [_vm._v(_vm._s(_vm.actualPrice || _vm.thisPrice))]), _vm._v("元")])]) : _vm._e()], 1), _vm._v(" "), _c('m-column', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "title": _vm.banks ? '续期账户' : '确认续期账户'
    }
  }, [_c('div', {
    staticClass: "payment-info",
    slot: "right"
  }, [_c('p', [_vm._v(_vm._s((_vm.banks ? '提示：' : '') + '剩余各期保费将从该银行卡中扣除'))])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "持卡人姓名"
    }
  }, [_vm._v(_vm._s(_vm.holderName))]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "身份证号"
    }
  }, [_vm._v(_vm._s(_vm.holderIdNumber))]), _vm._v(" "), (_vm.banks) ? [_c('popup-picker', {
    attrs: {
      "title": "银行",
      "data": _vm.banks,
      "show-name": "",
      "columns": 1,
      "placeholder": "请选择银行"
    },
    model: {
      value: (_vm.bankCode),
      callback: function($$v) {
        _vm.bankCode = $$v
      },
      expression: "bankCode"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "银行卡号",
      "max": 19,
      "type": "tel",
      "show-clear": false,
      "placeholder": "请输入银行卡号(不支持信用卡)",
      "text-align": "right",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.bankNumber),
      callback: function($$v) {
        _vm.bankNumber = $$v
      },
      expression: "bankNumber"
    }
  })] : [_c('cell', {
    attrs: {
      "title": "手机"
    }
  }, [_vm._v(_vm._s(_vm.holderPhone))]), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 4,
      "type": "tel",
      "show-clear": false,
      "title": "验证码",
      "placeholder": "请输入手机验证码",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderPhoneCAPTCHA
    },
    model: {
      value: (_vm.holderPhoneCAPTCHA),
      callback: function($$v) {
        _vm.holderPhoneCAPTCHA = $$v
      },
      expression: "holderPhoneCAPTCHA"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "disabled": _vm.CAPTCHACountdown === 0 ? false : true,
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendCAPTCHA($event)
      }
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.CAPTCHALabel))])], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "银行"
    }
  }, [_vm._v(_vm._s(_vm.bankName))]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "银行卡号"
    }
  }, [_vm._v(_vm._s(_vm.bankNumber))])]], 2)], 1)]), _vm._v(" "), _c('m-agree-iterms', {
    staticStyle: {
      "margin": "10px 0"
    },
    model: {
      value: (_vm.agreeTerms),
      callback: function($$v) {
        _vm.agreeTerms = $$v
      },
      expression: "agreeTerms"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.agreement)
    }
  })])]), _vm._v(" "), _c('tabbar', {
    staticClass: "payBar",
    slot: "bottom"
  }, [_c('div', {
    staticClass: "payBar-price"
  }, [_c('p', [_vm._v("价格："), _c('span', [_vm._v("￥"), _c('label', [_vm._v(_vm._s(_vm.actualPrice || _vm.thisPrice))]), _vm._v("/" + _vm._s(_vm.paymentUnit))])])]), _vm._v(" "), _c('div', {
    staticClass: "payBar-btn theme-bg-color",
    on: {
      "click": _vm.submitPay
    }
  }, [_c('span', [_vm._v("提交支付")])])]), _vm._v(" "), _c('x-dialog', {
    staticClass: "rules",
    model: {
      value: (_vm.ticketDialog),
      callback: function($$v) {
        _vm.ticketDialog = $$v
      },
      expression: "ticketDialog"
    }
  }, [_c('div', {
    staticClass: "head cf"
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/common/images/rules_bg.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("返现金额")]), _vm._v(" "), _c('span', {
    staticClass: "vux-close",
    on: {
      "click": function($event) {
        _vm.ticketDialog = false
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "body"
  }, [_c('p', [_vm._v("商品价格：" + _vm._s(_vm.actualPrice || _vm.thisPrice) + "元")]), _vm._v(" "), _c('p', [_vm._v("商品优惠：" + _vm._s(_vm.productBackMoney) + "元")]), _vm._v(" "), (_vm.couponsName) ? _c('p', [_vm._v("优惠劵：" + _vm._s(_vm.couponsName))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("返现金额：" + _vm._s(_vm.backMoney) + "元")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("注：返现金额将在支付成功后存入您的账户，关注悟空保微信号iwukongbao，进入“我的>个人中心>我的钱包”查看。")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7abdd32d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pay.vue
// module id = 684
// module chunks = 1